import { generatePath } from 'react-router';

import { Navigate, useTypedParams } from '@sorare/routing';

import { FOOTBALL_SCOUTING_CENTER_STATS_LEADERBOARDGROUP } from '@sorare/core/src/constants/__generated__/routes';

import type { PageParams } from './__generated__/routeParams';

export const ScoutingCenterSo5LeaderboardGroupRedirect = () => {
  const { leaderboardGroup } = useTypedParams<PageParams>();
  return (
    <Navigate
      to={generatePath(FOOTBALL_SCOUTING_CENTER_STATS_LEADERBOARDGROUP, {
        leaderboardGroup,
      })}
    />
  );
};

export default ScoutingCenterSo5LeaderboardGroupRedirect;
